





























































































































































































































import Vue from 'vue';
import { isNil } from 'lodash';
import UserMenu from '@/components/global-components/global-header-component/header-components/user-menu.component.vue';
import { EventBus } from '@/event-bus';

import { AuthService } from '@/services';

import { dialogMaxWidth } from '@/constants';
import { getContentArea } from '@/contentful';

interface Data {
  visible: boolean;
  dialogMaxWidth: string;
  signOutConfirm: boolean;
  learnLink: string;
}

export default Vue.extend({
  name: 'MobileMenuTray',
  props: {
    user: {
      type: Object as () => any,
    },
    page: {
      type: String,
      required: false,
      default: '',
    },
  },
  beforeMount() {
    getContentArea(['global-learn-link']).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.learnLink = contentAreas[0].fields.actionValue;
        }
      }
    });
  },
  data(): Data {
    return {
      visible: false,
      dialogMaxWidth,
      signOutConfirm: false,
      learnLink: '',
    };
  },
  mounted() {
    EventBus.$on('openMobileMenu', () => {
      this.openMobileMenu();
    });
  },
  destroyed() {
    EventBus.$off('openMobileMenu');
  },
  computed: {
    isAuthenticated(): boolean {
      return !isNil(this.user);
    },
  },
  methods: {
    openMobileMenu(): void {
      this.visible = true;
      EventBus.$emit('openNavTray');
    },
    closeMobileMenu(): void {
      this.visible = false;
      EventBus.$emit('closeNavTray');
    },
    logout(): void {
      AuthService.signOutUser(true);
    },
    confirmSignOut(): void {
      this.signOutConfirm = true;
    },
    isRoute(action): boolean {
      return action ? action.indexOf('route="') > -1 : false;
    },
    isLink(action): boolean {
      return action ? action.indexOf('link="') > -1 : false;
    },
    isSelfLink(action): boolean {
      return action ? action.indexOf('link:self="') > -1 : false;
    },
    constructRoute(action): string {
      let regex;
      if (this.isRoute(action)) {
        regex = /(route=")(.*)(")/g;
      } else if (this.isLink(action)) {
        regex = /(link=")(.*)(")/g;
      } else if (this.isSelfLink(action)) {
        regex = /(link:self=")(.*)(")/g;
      }
      return action.replace(regex, (match, a, b) => {
        return b;
      });
    },
  },
  components: {
    UserMenu,
  },
});
